export const TEST_ID = 'batteryDrawerTabBody';
